  <template>
    <section class="cta">
      <div class="cta__content container">
        <div class="cta__info">
          <p class="cta__text">
            For more information
          </p>
          <a class="cta__btn" href="mailto:puertorico@srax.com">
              <button class="button" :class="{'alt-style-1': alternativeStyling, 'big-font': biggerSize }">
                {{ message }}
              </button>
          </a>
        </div>
        <div class="cta__hotel">
          <p class="cta__text">
            Make your hotel reservations
          </p>
          <a class="cta__btn" target="_blank" href="https://www.marriott.com/event-reservations/reservation-link.mi?id=1677007507668&key=GRP&app=resvlink">
            <button class="button" :class="{'alt-style-1': alternativeStyling, 'big-font': biggerSize }">
              {{ message2 }}
            </button>
        </a>
        </div>
      </div>
    </section>
  </template>
  
  <script>

  export default {
    name: 'cta',
    props: {
      message: {
        type: String,
        default: 'Ask a Question'
      },
      message2: {
        type: String,
        default: 'Book Now'
      },
      alternativeStyling: {
        type: Boolean,
        required: false
      },
      biggerSize: {
        type: Boolean,
        required: false
      }
    },
    data () {
      return {
      }
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style lang="scss" scoped>
  @import "../styles/components/cta.scss";
  </style>
  